import { configureStore } from '@reduxjs/toolkit'
import { api, queryReducers } from 'mmfintech-checkout-commons'
import * as ReactDOMClient from 'react-dom/client'
import { Provider } from 'react-redux'
import App from './App'

import './i18n'

import 'react-phone-input-2/lib/style.css'
import 'react-datepicker/dist/react-datepicker.css'
import 'mmfintech-portal-commons/dist/main.css'
import './index.css'

export const store = configureStore({
  reducer: queryReducers,
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(api.middleware)
})

const root = ReactDOMClient.createRoot(document.getElementById('checkout-app'))
root.render(
  <Provider store={store}>
    <App />
  </Provider>
)
